<template>
  <el-select size="mini" v-model="value" placeholder="请选择类型" @change="changeValue">
    <el-option
      ref="option"
      v-for="item in options"
      :key="item[0]"
      :label="item[0]"
      :value="item[0]"
    ></el-option>
  </el-select>
</template> 

<script>
export default {
  data() {
    return {
      options: "",
      value: ""
    };
  },
  created() {},
  mounted() {
    // this.getCate();
  },
  methods: {
    changeValue(v) {
      this.$emit("getTypeValue", v);
    },
    
  }
};
</script>